/* ============================================================
   busca.js — sugestões enquanto digita (predictive search)
   ============================================================
   Liga em qualquer <form data-ps-form> com um input[name="q"] e um
   [data-ps-box]. A cada digitação (a partir de 2 letras, com espera de
   220 ms) busca /search/suggest com section_id=predictive-search e
   injeta o HTML da seção. Cancela a busca anterior, guarda em cache,
   navega com as setas, fecha com Esc ou clique fora. Sem JS, o form
   continua indo para /search normalmente. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = window.BellaBusca || {};
  var limite = cfg.limite || 6;

  function url(q) {
    return root + 'search/suggest?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection,query' +
      '&resources[limit]=10' +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,tag,vendor';
  }

  function init(form) {
    if (form.getAttribute('data-ps-ready')) return;
    var input = form.querySelector('input[name="q"]');
    var box = form.querySelector('[data-ps-box]');
    if (!input || !box) return;
    form.setAttribute('data-ps-ready', '1');

    var timer, ctrl, cache = {}, ativo = -1;
    var clear = form.querySelector('[data-ps-clear]');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', box.id);
    input.setAttribute('autocomplete', 'off');

    function itens() { return Array.prototype.slice.call(box.querySelectorAll('[data-ps-item]')); }
    function marcar(i) {
      var lista = itens();
      lista.forEach(function (el, k) { el.classList.toggle('is-active', k === i); if (k === i) el.scrollIntoView({ block: 'nearest' }); });
      ativo = i;
    }
    function fechar() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); ativo = -1; }
    function mostrar(html) {
      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      ativo = -1;
    }
    function carregando() {
      if (box.hidden || !box.querySelector('[data-ps-results]')) {
        box.innerHTML = '<p class="ps__loading">' + (cfg.carregando || '') + '</p>';
        box.hidden = false;
      }
      box.setAttribute('aria-busy', 'true');
    }
    function buscar(q) {
      if (cache[q] !== undefined) { mostrar(cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      carregando();
      fetch(url(q), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var tmp = document.createElement('div');
          tmp.innerHTML = t;
          var res = tmp.querySelector('[data-ps-results]');
          var html = res ? res.outerHTML : '';
          cache[q] = html;
          if (input.value.trim() === q) mostrar(html);
        })
        .catch(function () {})
        .then(function () { box.removeAttribute('aria-busy'); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clear) clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 2) { fechar(); return; }
      timer = setTimeout(function () { buscar(q); }, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && box.innerHTML) { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    });
    input.addEventListener('keydown', function (e) {
      var lista = itens();
      if (e.key === 'ArrowDown' && !box.hidden && lista.length) { e.preventDefault(); marcar(ativo + 1 >= lista.length ? 0 : ativo + 1); }
      else if (e.key === 'ArrowUp' && !box.hidden && lista.length) { e.preventDefault(); marcar(ativo - 1 < 0 ? lista.length - 1 : ativo - 1); }
      else if (e.key === 'Enter' && ativo > -1 && lista[ativo]) { e.preventDefault(); lista[ativo].click(); }
      else if (e.key === 'Escape') {
        if (!box.hidden) { fechar(); }
        else { var d = form.closest('details'); if (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); } }
      }
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; clear.hidden = true; fechar(); input.focus(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) fechar(); });
  }

  function iniciar() {
    document.querySelectorAll('[data-ps-form]').forEach(init);
    document.querySelectorAll('details[data-ps-details]').forEach(function (d) {
      if (d.getAttribute('data-ps-ready')) return;
      d.setAttribute('data-ps-ready', '1');
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        var input = d.querySelector('input[name="q"]');
        if (input) setTimeout(function () { input.focus(); }, 30);
      });
      document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.removeAttribute('open'); });
      var fechar = d.querySelector('[data-ps-close]');
      if (fechar) fechar.addEventListener('click', function () { d.removeAttribute('open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
